import logging from '@wr/logging';
import {gatewayService} from '@wr/plutonium/services';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import eventIds from '../event-ids';
import {getTargetOrigin} from '../utils/getTargetOrigin';
import {getPaymentSessionId} from '../utils/helpers';
import config from '../config';


const getCybersourceCardDetails = async ({
    languageCode, sessionId, requestId, params, query
}) => {
    const paymentSessionId = getPaymentSessionId(params, query);
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const logProps = {requestId, sessionId, paymentSessionId};

    logger.info('Retrieving Cybersource card details', {
        eventId: eventIds['Retrieving Cybersource card details'],
        ...logProps
    });

    try {
        const client = gatewayService({requestId, sessionID: sessionId}, languageCode);
        const cardDetails = await client.cybersource.cardDetails(paymentSessionId, getTargetOrigin());

        logger.info('Retrieved Cybersource card details', {
            eventId: eventIds['Retrieved Cybersource card details'],
            ...logProps,
            payload: cardDetails
        });

        return cardDetails;
    } catch (e) {
        const error = new Error(`Error retrieving Cybersource card details: ${e.message}`);

        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving Cybersource card details'],
            ...logProps
        });

        throw error;
    }
};

export default getCybersourceCardDetails;
